import {
  SELEZIONA_DETTAGLIO_CRIMINE,
  PULISCI_DETTAGLIO_CRIMINE,
  DEFINISCI_STATI_RAPINA,
  DEFINISCI_STATI_INTERVENTI_RAPINA,
  DEFINISCI_STATI_BOTTINO_RAPINA,
  DEFINISCI_STATI_CONSEGUENZE_RAPINA,
  DEFINISCI_STATI_FURTO,
  DEFINISCI_STATI_INTERVENTI_FURTO,
  DEFINISCI_STATI_BOTTINO_FURTO,
  DEFINISCI_STATI_CONSEGUENZE_FURTO,
  DEFINISCI_STATI_MODALITA,
  DEFINISCI_STATI_COSTI_EVENTO,
  DEFINISCI_STATI_OSTAGGI,
  DEFINISCI_STATI_ALTRIEVENTI
} from 'Actions/ossif/ossifTypes'

export const statoCaricamento = (statoCaricamento) => ({
  type: LOAD_DATA,
  payload: statoCaricamento
})

export const selezionaDettaglioCrimine = (dettaglio) => ({
  type: SELEZIONA_DETTAGLIO_CRIMINE,
  payload: dettaglio
})

export const pulisciDettaglioCrimine = () => ({
  type: PULISCI_DETTAGLIO_CRIMINE
})

//Rapine
export const definisciStatiSezRapina = (domandeRisposteRapina) => ({
  type: DEFINISCI_STATI_RAPINA,
  payload: domandeRisposteRapina
})

export const definisciStatiSezInterventiRapina = (
  domandeRisposteInterventoRapina
) => ({
  type: DEFINISCI_STATI_INTERVENTI_RAPINA,
  payload: domandeRisposteInterventoRapina
})

export const definisciStatiSezBottinoRapina = (
  domandeRisposteBottinoRapina
) => ({
  type: DEFINISCI_STATI_BOTTINO_RAPINA,
  payload: domandeRisposteBottinoRapina
})

export const definisciStatiSezConseguenzeRapina = (
  domandeRisposteConseguenzeRapina
) => ({
  type: DEFINISCI_STATI_CONSEGUENZE_RAPINA,
  payload: domandeRisposteConseguenzeRapina
})

//Furti
export const definisciStatiSezFurto = (domandeRisposteFurto) => ({
  type: DEFINISCI_STATI_FURTO,
  payload: domandeRisposteFurto
})

export const definisciStatiSezInterventiFurto = (
  domandeRisposteInterventoFurto
) => ({
  type: DEFINISCI_STATI_INTERVENTI_FURTO,
  payload: domandeRisposteInterventoFurto
})

export const definisciStatiSezBottinoFurto = (domandeRisposteBottinoFurto) => ({
  type: DEFINISCI_STATI_BOTTINO_FURTO,
  payload: domandeRisposteBottinoFurto
})

export const definisciStatiSezConseguenzeFurto = (
  domandeRisposteConseguenzeFurto
) => ({
  type: DEFINISCI_STATI_CONSEGUENZE_FURTO,
  payload: domandeRisposteConseguenzeFurto
})

//solo Rapine
export const definisciStatiSezModalita = (domandeRispostemodalita) => ({
  type: DEFINISCI_STATI_MODALITA,
  payload: domandeRispostemodalita
})

export const definisciStatiSezCostiEvento = (domandeRisposteCostiEvento) => ({
  type: DEFINISCI_STATI_COSTI_EVENTO,
  payload: domandeRisposteCostiEvento
})
export const definisciStatiSezOstaggi = (domandeRisposteOstaggi) => ({
  type: DEFINISCI_STATI_OSTAGGI,
  payload: domandeRisposteOstaggi
})
export const definisciStatiSezAltriEventi = (domandeRisposteAltriEventi) => ({
  type: DEFINISCI_STATI_ALTRIEVENTI,
  payload: domandeRisposteAltriEventi
})
